import type { BacklogListImport } from "../../../../../_shared/_logic/batch-upload-contract"

type SourceRow = BacklogListImport["rows"][number]

/** Keep import observations attached to their source and the target actually checked. */
export const backlogMatchReview = (
  source: SourceRow,
  sourceSystem: BacklogListImport["sourceSystem"] | undefined,
  target: {
    propertyId: string | null
    selectedUnitId: string | null
    workTargetSelectedManually?: boolean
  },
) => {
  const location =
    sourceSystem === "portal_kamin_futura" || sourceSystem === "isi_export"
      ? source.source_line_start
        ? `Dateizeile ${source.source_line_start}${source.source_line_end && source.source_line_end !== source.source_line_start ? ` bis ${source.source_line_end}` : ""}`
        : `Eintrag ${source.row_number}`
      : `Seite ${source.page_number} · Eintrag ${source.row_number}`
  const appliesToSelection =
    source.property_id === target.propertyId &&
    (source.property_unit_id
      ? source.property_unit_id === target.selectedUnitId
      : !target.workTargetSelectedManually)
  const hints = [
    ...(source.match_reason === "address_unverifiable"
      ? [
          "Adresse nicht eindeutig lesbar. Die Zuordnung konnte beim Import nicht anhand der Adresse geprüft werden.",
        ]
      : []),
    ...(source.match_warnings ?? []).flatMap((warning) => {
      const label = {
        city_mismatch: "Ort",
        postal_code_mismatch: "Postleitzahl",
      }[warning.code]

      if (!label) return []

      return [
        warning.target_value === null
          ? `${label} aus der Liste: „${warning.source_value}“. In der geprüften Liegenschaft fehlt diese Angabe.`
          : `${label} weicht ab: Liste „${warning.source_value}“, geprüfte Liegenschaft „${warning.target_value}“.`,
      ]
    }),
  ]

  return { location, appliesToSelection, hints }
}
